import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=5c5cd241&scoped=true&"
var script = {}
import style0 from "./bottom.vue?vue&type=style&index=0&id=5c5cd241&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5cd241",
  null
  
)

export default component.exports